"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var LocalTokenStore = /*#__PURE__*/function () {
  function LocalTokenStore(tokens) {
    (0, _classCallCheck2["default"])(this, LocalTokenStore);
    this._tokens = tokens || {};
  }

  (0, _createClass2["default"])(LocalTokenStore, [{
    key: "updateTokens",
    value: function updateTokens(tokens) {
      Object.assign(this._tokens, tokens);
    }
  }, {
    key: "id",
    set: function set(token) {
      this._tokens.id = token;
    },
    get: function get() {
      return this._tokens.id;
    }
  }, {
    key: "access",
    set: function set(token) {
      this._tokens.access = token;
    },
    get: function get() {
      return this._tokens.access;
    }
  }, {
    key: "refresh",
    set: function set(token) {
      this._tokens.refresh = token;
    },
    get: function get() {
      return this._tokens.refresh;
    }
  }]);
  return LocalTokenStore;
}();

exports["default"] = LocalTokenStore;